import { useEffect } from 'react';
import { checkWhichIconMustToBeReturned } from '../../../classes/functions';
import { RiCheckboxMultipleFill } from "react-icons/ri";
import { ImCross } from "react-icons/im";
import { FaCheck } from "react-icons/fa";
import { useLocation } from 'react-router-dom';
import './index.css';

export default function SelectStatus({showSelectStatus, setShowSelectStatus, listStatus, setListStatus, selectedStatus, setSelectedStatus, setStatusButtonWasClicked}){
    function checkStatus(modifiedStatus){
        setListStatus(listStatus.map((status) => {
            if(status.chave === modifiedStatus){
                status.checked = !status.checked;
            }

            return status;
        }));
    }

    function applyFilters(){
        let checkedStatusExists = listStatus.filter((status) => status?.checked).length !== 0;

        if(!checkedStatusExists){
            setSelectedStatus("");
        }

        listStatus.map((status) => {
            let splittedSelectedStatus = selectedStatus?.split(",");

            if(status?.checked && ((selectedStatus !== "" && !splittedSelectedStatus?.includes(status?.chave)) || selectedStatus === "")){
                setSelectedStatus(selectedStatus += `${selectedStatus === "" ? "" : ","}${status.chave}`);
            }

            if(!status?.checked && splittedSelectedStatus?.includes(status?.chave)){
                let newStringForSelectedStatus = "";

                splittedSelectedStatus?.map((splittedStatus) => {
                    if(listStatus?.filter((statusOfList) => statusOfList.chave === splittedStatus).length !== 0 && splittedStatus !== status?.chave){
                        newStringForSelectedStatus += `${newStringForSelectedStatus === "" ? "" : ","}${splittedStatus}`;
                    }
                });
                
                setSelectedStatus(newStringForSelectedStatus);
            }

            return status;
        });
    }

    function checkOrUncheckAllStatus(){
        let existsOneStatusChecked = listStatus?.filter((status) => status?.checked).length !== 0;

        setListStatus(listStatus?.map((status) => {
            if(existsOneStatusChecked){
                status.checked = false;
            } else{
                status.checked = true;
            }

            return status;
         }));
    }

    function convertSearchStatusToStringFormat(){
        const valuesToReplace = [
          {currentValue: "%C3%87", newValue: "Ç"},
          {currentValue: "%20", newValue: " "}
        ];
    
        let statusValueInURL = window.location.search.split("?status=")[1];
    
        for(let i = 0; i < valuesToReplace.length; i++){
          if(statusValueInURL?.includes(valuesToReplace[i].currentValue)){
            statusValueInURL =  statusValueInURL.replace(valuesToReplace[i].currentValue, valuesToReplace[i].newValue)
          }
        }
    
        return statusValueInURL;
      }
    
    function filterListIfStatusWasReceivedByURL(){
        if(convertSearchStatusToStringFormat()){
            setListStatus(listStatus?.map((status) => {
                if(status.descricao === convertSearchStatusToStringFormat() || window.location.search.split("?status=")[1]?.includes(status.chave)){
                    status.checked = true;
                }

                return status;
            }));

            applyFilters();

            setStatusButtonWasClicked(true);
        }
    }

    function confirmStatusChange(){
        console.log(selectedStatus)
        const newURL = `${window.location.pathname}?status=${selectedStatus}`;
        setStatusButtonWasClicked(true);
        
        window.history.pushState({}, "", newURL);
    }

    useEffect(() => {
        applyFilters();
    }, [listStatus]);

    useEffect(() => {
        filterListIfStatusWasReceivedByURL();
    }, []);

    return (
        <form className="check" style={{display: showSelectStatus ? "flex" : "none"}}>
            {listStatus?.map((item, index) => {
                return (
                    <>
                        <div onClick={(e) => e.defaultPrevented} className="check__status">
                            <input className="check___input" type="checkbox" key={index} onChange={(e) => checkStatus(e.target.value)} checked={item?.checked} value={item?.chave} />
                            <div className="check___description">
                                {checkWhichIconMustToBeReturned(item?.descricao, "1.5rem")}
                                <h2>{item?.descricao}</h2>
                            </div>
                        </div>
                    </>
                )
            })}
            <div className="check__icons">
                <button type="button" className="check___icon" onClick={confirmStatusChange} ><FaCheck title="Confirmar" /></button>
                <button type="button" className="check___icon" onClick={checkOrUncheckAllStatus}><RiCheckboxMultipleFill title="Marcar/Desmarcar todos" /></button>
                <button type="button" className="check___icon" onClick={() => setShowSelectStatus(false)}><ImCross title="Fechar" /></button>
            </div>
        </form>
    );
}